import { useCallback } from 'react'
import { useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'

export const useInvalidateSalesReports = () => {
  const queryClient = useQueryClient()

  const invalidateSalesReports = useCallback(async () => {
    await queryClient.invalidateQueries(QueryKeys.DocumentReportsSalesOverview)
    await queryClient.invalidateQueries(QueryKeys.DocumentReportsSalesByCustomer)
    await queryClient.invalidateQueries(QueryKeys.DocumentReportsSalesByItem)
  }, [queryClient])

  return {
    invalidateSalesReports,
  }
}
